// src/components/HourSlot.jsx
import React from "react";
import WorkSchedule from "./WorkSchedule";
import styles from "./HourSlot.module.css";
import {getDynamicColorForPercentage, getStaticColorColorForPercentage, getScaleColorForPercentage, getContrastingTextColor} from "../utils/colorUtils";

/**
 * Props:
 * - hourData: for cutters -> { hour: "HH", percent: number }
 *             for press   -> { hour: "HH", count: number }
 * - machine: machine object; must contain .type and optional .schedule
 */
function HourSlot({hourData, machine}) {
  const isPress = machine?.type === "press";
  const hour = hourData?.hour ?? "--";

  // Schedule segments for this hour (from DB)
  const hourKey = String(hour).padStart(2, "0");
  const combinedSegments = machine?.segmentsByHour?.[hourKey] && Array.isArray(machine.segmentsByHour[hourKey]) ? machine.segmentsByHour[hourKey] : [];

  // Value to display:
  // - press: show raw count
  // - cutters: show percent (rounded down)
  const valueToShow = isPress ? Number(hourData?.count) || 0 : Math.floor(Number(hourData?.percent) || 0);

  // Background/text color:
  // - cutters: keep percentage-based color scale
  // - press: neutral background, dark text
  let bgColor, textColor;
  if (isPress) {
    bgColor = "rgb(200, 200, 200)";
    //textColor = "#222";
  } else {
    const percent = Number(hourData?.percent) || 0;
    // You may keep only getScaleColorForPercentage if dynamic/static are unused elsewhere
    const scaleColor = getScaleColorForPercentage(percent, machine.colorConfig);
    bgColor = scaleColor;
    textColor = getContrastingTextColor(scaleColor);
  }

  return (
    <div className={styles.hourWrapper}>
      <div className={styles.hourLabel}>{hour}</div>
      <div className={styles.hourSlot} data-hour={hour} data-machine-name={machine.name || "No name"} style={{backgroundColor: bgColor, color: textColor}}>
        {isPress ? valueToShow : `${valueToShow}%`}
        <WorkSchedule segments={combinedSegments} />
      </div>
    </div>
  );
}

export default HourSlot;
